._gridLines_cu54c_1 {
  pointer-events: none;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  shape-rendering: crispEdges; }
  ._gridLines_cu54c_1._fade_cu54c_9 {
    opacity: 0; }
  ._gridLines_cu54c_1 line {
    stroke-width: 1; }
    ._gridLines_cu54c_1 line._backLine_cu54c_13 {
      stroke: #ffffff; }
    ._gridLines_cu54c_1 line._frontLine_cu54c_15 {
      stroke: #000000;
      stroke-dasharray: 5 5; }
